module.exports = __webpack_public_path__ + "img/132ne.07bbc591.svg";